export interface Document {
    identifiant: number;
    identifiantEntite: number;
    identifiantLogin: number;
    identifiantModInfo?: number;
    libelle: string;
    extension: string;
    dateCreation: Date| string;
    dateModification: Date | string;
    description: string;
    type: string;
    code: string;
    identifiantOrigine: number;
    identifiantReference: number;
    origineProduit: number;
    periodeDemat: string;
    identifiantStockageObjet: string;
    insererDansGed: number;
    masquePortail: number;
    bpPartiel: number;
    nomenclature: string;
    controle: number;
    notifEsag: number;
    coffreFort: number;
    dateEnvoiNotifEsag: Date | string;
}


export interface DocumentJoint {
    identifiant: number;
    identifiantOrigine: number;
    libelle: string;
    code: string;
    type: string;
    extension: string
}

export enum DocumentTypes{
    IMG_ACTU = "ActualiteImage",
    DOC_ACTU = "ActualiteDoc",
}

export interface CustomFile {
  uri: string,
  name: string,
  type: string,
}